module.exports = __webpack_public_path__ + "img/caigouxinxiBanner.1a68930a.png";